angular.module('rjmNg.directives').directive "inputDropdown", [
  "$document"
  ($document) ->
    restrict: "A"
    require: "ngModel"
    priority: 1000
    link: (scope, elm, attrs, ngModel) ->

      reset = ->
        elm.parent().removeClass("open")
        $document.off "click.input.dropdown.directive"

      elm.parent().children(".js-search-button").on "click", (event) ->
        if not elm.parent().hasClass('open')
          scope.$apply ->
            ngModel.$setViewValue("")
          elm.val("")
          elm.dropdown("toggle")
          $document.on "click.input.dropdown.directive", reset

        return false

      #prevent clicks in the dropdown menu from closing the dropdown
      elm.parent().on "click.dropdown-menu", (event) ->
        if $(event.target).is("a") or $(event.target).parents("a").length > 0
          reset()
          return
        event.stopPropagation()
        return false

      elm.on "keydown", (event) ->
        elm.data("dropdown").keydown.call(this, event)

      elm.dropdown()
      elm.off "click.dropdown.data-api" #turn of default bootstrap click handeling because we want to handle it.

      elm.on "$destroy", ->
        $("html").off "click.input.dropdown.directive"

  ]
